// extracted by mini-css-extract-plugin
module.exports = {"closed":"_96UY+w87YLZQ3FvwLerrsQ==","opened":"VjVhjVhY2w6vp6h45C0k8A=="};